import { Injectable } from '@angular/core';
import { ConsumptionProfile, FormKeys, HeatLoadCalculationMethod, ProjectType } from '@nx-customer-apps/shared/enums';
import { FormOptions, RadioQuestionOverride } from '@nx-customer-apps/shared/interfaces';
import { RadioQuestion, TextboxQuestion } from '@nx-customer-apps/shared/utils';
import { CommonFormService } from '../../../../services';

@Injectable({
    providedIn: 'root'
})
export class HeatingDistributionFormService {
    constructor(private commonFormService: CommonFormService) {}

    public getHeatingDistributionQuestions(options?: FormOptions): (RadioQuestion | TextboxQuestion)[] {
        const distributionMethod = this.commonFormService.getDistributionMethod(options);
        const distributionMethodOverride = options?.questions?.[FormKeys.DistributionMethod];
        distributionMethod.value = distributionMethodOverride?.value || distributionMethod.value;

        const heatingFlowTemperature = this.commonFormService.getHeatingFlowTemperature(options);
        const heatingFlowTemperatureOverride = options?.questions?.[FormKeys.HeatingFlowTemperature];
        heatingFlowTemperature.value = heatingFlowTemperatureOverride?.value || heatingFlowTemperature.value;

        const questions = [distributionMethod, heatingFlowTemperature];

        const heatingScheduleOverride = options?.questions?.[FormKeys.HeatingSchedule] as RadioQuestionOverride;

        if (!heatingScheduleOverride?.options) {
            throw Error('Please specify options for heating schedule question');
        }

        if (
            options?.projectType === ProjectType.Renovation &&
            (options?.heatLoadCalculationMethod === HeatLoadCalculationMethod.LivingSpace ||
                options?.heatLoadCalculationMethod === HeatLoadCalculationMethod.CustomValue ||
                options?.heatLoadCalculationMethod === HeatLoadCalculationMethod.BuildingHull)
        ) {
            heatingScheduleOverride.value = ConsumptionProfile.NocturnalFall;
        }

        const heatingSchedule = this.commonFormService.getHeatingSchedule(heatingScheduleOverride);
        heatingSchedule.value = heatingScheduleOverride?.value || heatingSchedule.value;

        questions.push(heatingSchedule);

        return questions;
    }
}
